const initialState = {
  roles: [],
  departments: [],
  designations: [],
  holidays: [],
  permission_modules: [],
  permission_masters: [],
  challans: [],
  error: null,
  isLoding: false
};

const MasterApiReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOADING":
      return {
        ...state,
        isLoding: action.payload
      };

    case "GET_ROLES_SUCCESS":
      return {
        ...state,
        roles: action.payload,
        error: null
      };
    case "GET_ROLES_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "GET_PERMISSION_MASTERS_SUCCESS":
      return {
        ...state,
        permission_masters: action.payload,
        error: null
      };

    case "ADD_ROLE_SUCCESS":
      return {
        ...state,
        error: null
      };
    case "ADD_ROLE_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "UPDATE_ROLE_SUCCESS":
      return {
        ...state,
        error: action.payload.error
      };

    case "UPDATE_ROLE_FAILURE":
      return {
        ...state,

        error: action.payload.error
      };

    case "DELETE_ROLE_SUCCESS":
      return {
        ...state,
        roles: state.roles.filter((role) => role.id !== action.payload),
        error: null
      };

    case "DELETE_ROLE_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "GET_DEPARTMENTS_SUCCESS":
      return {
        ...state,
        departments: action.payload,
        error: null
      };

    case "GET_DEPARTMENTS_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "ADD_DEPARTMENTS_SUCCESS":
      return {
        ...state,
        departments: [...state.departments, action.payload],
        error: null
      };

    case "ADD_DEPARTMENTS_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "UPDATE_DEPARTMENT_SUCCESS":
      return {
        ...state,
        error: action.payload.error
      };

    case "UPDATE_DEPARTMENT_FAILURE":
      return {
        ...state,

        error: action.payload.error
      };

    case "DELETE_DEPARTMENT_SUCCESS":
      return {
        ...state,
        departments: state.roles.filter((role) => role.id !== action.payload),
        error: null
      };

    case "DELETE_DEPARTMENT_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "GET_DESIGNATIONS_SUCCESS":
      return {
        ...state,
        designations: action.payload,
        error: null
      };

    case "GET_DESIGNATION_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "ADD_DESIGNATION_SUCCESS":
      return {
        ...state,

        error: null
      };

    case "ADD_DESIGNATION_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "UPDATE_DESIGNATION_SUCCESS":
      return {
        ...state,
        error: action.payload.error
      };

    case "UPDATE_DESIGNATION_FAILURE":
      return {
        ...state,

        error: action.payload.error
      };

    case "DELETE_DESIGNATION_SUCCESS":
      return {
        ...state,
        designations: state.roles.filter((role) => role.id !== action.payload),
        error: null
      };

    case "DELETE_DESIGNATION_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "GET_MASTER_HOLIDAYS_SUCCESS":
      return {
        ...state,
        holidays: action.payload,
        error: null
      };

    case "GET_HOLIDAYS_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "ADD_HOLIDAYS_SUCCESS":
      return {
        ...state,
        // holidays: [...state.holidays, action.payload],
        error: null
      };

    case "ADD_HOLIDAYS_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "UPDATE_HOLIDAY_MASTER_SUCCESS":
      return {
        ...state,
        error: action.payload.error
      };

    case "UPDATE_HOLIDAY_MASTER_FAILURE":
      return {
        ...state,

        error: action.payload.error
      };

    case "GET_PERMISSION_MODULES_SUCCESS":
      return {
        ...state,
        permission_modules: action.payload.modules,
        error: null
      };
    case "GET_PERMISSION_MODULES_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "GET_CHALLAN_MASTER_SUCCESS":
      return {
        ...state,
        challans: action.payload,
        error: null
      };
    case "GET_CHALLAN_MASTER_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

     case "ADD_CHALLAN_MASTER_SUCCESS":
      return {
        ...state,
       
        error: null
      };

    case "ADD_CHALLAN_MASTER_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };
    
    case "UPDATE_CHALLAN_SUCCESS":
      return {
        ...state,
        error: action.payload.error
      };

    case "UPDATE_CHALLAN_FAILURE":
      return {
        ...state,

        error: action.payload.error
      };
    
    default:
      return state;
  }
};

export default MasterApiReducer;
